var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartaoAtualizacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#5AB2AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.52 29.5714C13.332 29.5714 12.315 29.156 11.469 28.3251C10.623 27.4942 10.2 26.4954 10.2 25.3286V16.8429C10.2 15.6761 10.623 14.6772 11.469 13.8463C12.315 13.0155 13.332 12.6 14.52 12.6H27.48C28.668 12.6 29.685 13.0155 30.531 13.8463C31.377 14.6772 31.8 15.6761 31.8 16.8429V25.3286C31.8 26.4954 31.377 27.4942 30.531 28.3251C29.685 29.156 28.668 29.5714 27.48 29.5714H14.52ZM14.52 16.8429H27.48C27.876 16.8429 28.254 16.8871 28.614 16.9755C28.974 17.0638 29.316 17.2053 29.64 17.3997V16.8429C29.64 16.2595 29.4283 15.7599 29.005 15.3441C28.5816 14.9283 28.0733 14.7207 27.48 14.7214H14.52C13.926 14.7214 13.4173 14.9293 12.994 15.3451C12.5706 15.7609 12.3593 16.2602 12.36 16.8429V17.3997C12.684 17.2053 13.026 17.0638 13.386 16.9755C13.746 16.8871 14.124 16.8429 14.52 16.8429ZM12.522 20.2902L24.537 23.1541C24.699 23.1895 24.861 23.1895 25.023 23.1541C25.185 23.1188 25.338 23.048 25.482 22.942L29.235 19.8659C29.037 19.6007 28.785 19.384 28.479 19.2157C28.173 19.0474 27.84 18.9636 27.48 18.9643H14.52C14.052 18.9643 13.6427 19.0838 13.2921 19.3228C12.9414 19.5618 12.6847 19.8843 12.522 20.2902Z",
    fill: "#FDF6EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartaoAtualizacao);
export default __webpack_public_path__ + "static/media/cartaoAtualizacao.792b89f554d8b498830505e4874f7563.svg";
export { ForwardRef as ReactComponent };